import React from 'react';

interface FoldableSectionProps {
    title: string;
    expanded: boolean;
    setExpanded: (expanded: boolean) => void;
    disabled?: boolean;
    info?: React.ReactNode;
    children: React.ReactNode;
    halfFolded?: boolean;
}

const FoldableSection: React.FC<FoldableSectionProps> = ({
    title,
    expanded,
    setExpanded,
    disabled = false,
    info,
    children,
    halfFolded = false
}) => {
    return (
        <div className="foldable-section">
            <button
                className="section-header"
                onClick={() => !disabled && setExpanded(!expanded)}
                disabled={disabled}
            >
                <h2>{title}</h2>
                {info && (
                    <div className="selected-info">
                        {info}
                    </div>
                )}
                <span className={`expand-icon ${expanded ? 'expanded' : ''}`}>
                    {expanded ? '−' : '+'}
                </span>
            </button>

            <div className={`section-content ${halfFolded ? 'half-folded' : ''} ${expanded ? 'expanded' : ''}`}>
                {children}
            </div>
        </div>
    );
};

export default FoldableSection;